// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

const state = {
  site: {}
}

const getters = {
  selectedSite: state => state.site,

  filters: (state, getters) => {
    var filter = []
    if (getters.selectedSite) {
      filter.push({
        name: 'site',
        value: getters.selectedSite._id
      })
    }
    return filter
  }
}

const mutations = {
  setSite (state, site) {
    state.site = site
  }
}

const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/selectors.js